import axios from 'axios';
import { handleRequest } from 'helpers/api';

const AUTH_URL = `${process.env.REACT_APP_API_URL}/auth`;

axios.defaults.withCredentials = true;

const authApi = axios.create({
  baseURL: AUTH_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

export interface User {
  id?: string;
  email: string;
  password: string;
  fullName?: string;
  role?: 'customer' | 'vendor';
  avatar?: string;
  _id?: string;
}

export const loginUser = async (user: User) => {
  return handleRequest(authApi.post('/login', user));
};

export const registerUser = async (user: User) => {
  return handleRequest(authApi.post('/register', user));
};

export const logoutUser = async () => {
  return handleRequest(authApi.get('/logout'));
};

export const verifyUser = async () => {
  return handleRequest(authApi.get('/verify'));
};

export const checkEmailAvailability = async (email: string) => {
  return handleRequest(authApi.get(`/check-email-availability?email=${email}`));
};

export const updateAvatar = async (avatar: string) => {
  return handleRequest(authApi.put('/update-avatar', { avatar }));
};
